import React from "react";

import { ConnectExternalAccountStep } from "@shared/features/configuration/types";

export const ExternalConnectAccountContext = React.createContext<
  | {
      isExternalConnectAccount?: boolean;
      accountName?: string;
      token?: string;
      exchange?: string;
      step: ConnectExternalAccountStep;
      setStep: (step: ConnectExternalAccountStep) => void;
      isError?: boolean;
      errorMessage?: string;
    }
  | undefined
>(undefined);
